import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countrySearch'
})
export class CountrySearchPipe implements PipeTransform {

  transform(arr: any, root: any): any {
    console.log(arr)
    if ( root == '' || root == null || root == undefined || root == 'Search By Area' || root == 'All' || root == 'Search By Store' || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.adress.toLowerCase().includes(root.toLowerCase())
      })
    }
  }

}
